<template>
  <el-dialog width="300px" :before-close="() => {
      this.$emit('close');
    }
    " :show-close="false" @closed="closeModal">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="() => {
            $emit('close');
            this.showLoginModal = true;
          }
          ">
          <i class="theincircle-icon theincircle-arrow-left"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="logo-login">
          <a class="hidden-xs hidden-sm" href="/" title="The incircle" data-toggle="tooltip"><img
              src="@/assets/images/logo.svg" /></a>
        </div>
        <h3>Employer/Recruiter</h3>
        <p>(Looking for hire staff)</p>
        <br />

        <!-- <form> -->
        <div class="form-group" id="mobno">
          <label for="exampleInputEmail1" v-if="!isLoginOTPSent">Login with email or mobile number</label>

          <input type="text" class="form-control" id="exampleInputEmail1" v-if="!isLoginOTPSent"
            placeholder="Enter Email address / Mobile Number" v-model="loginId"
            @keypress="(e) => handleEnterKeyPress(e, 'LOGIN')" />
        </div>
        <div class="form-group" id="loginOtp">
          <label for="exampleInputEmail1" v-if="isLoginOTPSent">Enter OTP from mail or message</label>
          <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Enter Otp" v-model="otp"
            v-if="isLoginOTPSent" aria-describedby="emailHelp"
            @keypress="(e) => handleEnterKeyPress(e, 'Enter Otp')" /><br />
          <p class="text-left">
            <span style="{cursor : pointer}" v-if="isLoginOTPSent" @click="resendOTP">Resend OTP {{ otpTimer }}
              <a href="#" class="text-primary cursor-pointer"><i class="fa fa-hand-o-right"></i> Resend OTP</a></span>
          </p>
        </div>
        <button v-if="!isLoginOTPSent" type="submit" class="btn btn-block other-profile" id="formotp"
          @click="onClickLogin" :disabled="!loginId || loginOTPResponse.isverifying">
          Login with OTP
        </button>
        <button type="button" class="btn btn-block other-profile" id="btn_loginOtp" data-dismiss="modal"
          aria-label="Close" v-if="isLoginOTPSent" @click="onSubmitOTP">
          Submit
        </button>

        <br /><br />
        <div class="sign-up" @click="$emit('close')">
          New User? <router-link to="/register">Register here</router-link>
        </div>
        <!-- </form> -->
      </div>
      <div class="modal-footer">
        <p>© 2024 TAGGER TECHNOLOGIES LLP, All Rights Reserved.</p>
      </div>
    </div>
    <!-- <span slot="footer">
      <el-button type="primary" @click="$emit('close')">Close</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
export default {
  name: "LoginModal",
  props: {
    showModal: Boolean,
    message: String,
    buttonName: String,
  },
  data() {
    return {
      loginId: "",
      otp: "",
      isLoginOTPSent: false,
      otpTimer: 60,
      intervalTimer: null,
    };
  },
  computed: {
    ...mapState({
      loginRes: (state) => state.AuthModule.loginResponse,
      loginOTPResponse: (state) => state.AuthModule.loginOTPResponse,
    }),
  },
  watch: {
    loginRes() {
      if (!this.loginRes.isLoging) {
        if (this.loginRes.responseData.status === 200) {
          this.isLoginOTPSent = true;
          this.countDownTimer();
        } else {
          this.$message({
            message: this.loginRes.responseData.message,
            type: "error",
            offset: 80,
          });
        }
      }
    },
    loginOTPResponse() {
      if (!this.loginOTPResponse.isverifyingLoginOTP) {
        if (this.loginOTPResponse.responseData.status === 200) {
          var now = new Date();
          var time = now.getTime();
          var expireTime = time + 3600 * 1000 * 24 * 365 * 1;
          now.setTime(expireTime);
          Cookies.set(
            "userId",
            this.loginOTPResponse.responseData.data.userId,
            { path: "/", expires: now }
          );
          Cookies.set(
            "authToken",
            this.loginOTPResponse.responseData.data.authToken,
            { path: "/", expires: now }
          );
          Cookies.set(
            "companyName",
            this.loginOTPResponse.responseData.data.companyName,
            { path: "/", expires: now }
          );
          if (this.loginOTPResponse?.responseData?.data?.companyName) {
            localStorage.setItem('companyName', this.loginOTPResponse.responseData.data.companyName)
          }
          Cookies.set(
            "contactPerson",
            this.loginOTPResponse.responseData.data.contactPerson,
            { path: "/", expires: now }
          );

          // this.$router.push("/dashboard");
          this.$emit("change-route");
          this.closeModal();
        } else {
          this.$message({
            message: this.loginOTPResponse.responseData.message,
            type: "error",
            offset: 80,
          });
        }
      }
    },
  },

  methods: {
    clickOnRegister() {
      this.$emit("close");
      this.$router.push("/register");
    },
    onClickLogin() {
      const loginObj = { username: this.loginId };
      this.$store.dispatch("AuthModule/actionLoginEmployer", loginObj);
      // var now = new Date();
      // var time = now.getTime();
      // var expireTime = time + (3600 * 1000 * 24 * 365 * 1);
      // now.setTime(expireTime);
      // Cookies.set('userId', "1234", {path: '/', expires: now });
      // Cookies.set('authToken', "jdshsgsggshghggfgdfg", { path: '/',expires: now })
      // alert("fdfd");
    },
    closeModal() {
      this.otpTimer = 60;
      this.isLoginOTPSent = false;
      this.$emit("close");
      this.loginId = "";
      this.isLoginOTPSent = false;
      this.otp = "";
      // this.destroyed();
    },
    onSubmitOTP() {
      const loginObj = { username: this.loginId, otp: this.otp };
      this.$store.dispatch("AuthModule/actionVerifyLoginOTP", loginObj);
    },
    resendOTP() {
      this.otpTimer = 60;
      this.countDownTimer();
      this.onClickLogin();
      // this.this.onSubmitOTP();
    },

    handleEnterKeyPress(e, evName) {
      if (e.charCode === 13) {
        if (evName === "LOGIN") {
          this.onClickLogin();
        } else if (evName === "OTP") {
          this.onSubmitOTP();
        }
      }
    },
    countDownTimer() {
      clearInterval(this.intervalTimer);
      this.intervalTimer = setInterval(() => {
        this.otpTimer--;
        if (this.otpTimer === 0) {
          clearInterval(this.intervalTimer);
        }
      }, 1000);
    },
  },
  unmounted() {
    this.otpTimer = 60;
    this.isLoginOTPSent = false;
    this.loginId = "";
    this.isLoginOTPSent = false;
    this.otp = "";
    clearInterval(this.intervalTimer);
  },
};
</script>

<style>
.cursor-pointer {
  cursor: pointer !important;
}
</style>
